import styled from "styled-components";

export const PriceFilter = styled.div`
  .input-range__slider {
    appearance: none;
    background: #3f51b5;
    border: 1px solid #3f51b5;
    border-radius: 100%;
    cursor: pointer;
    display: block;
    height: 1rem;
    margin-left: -0.5rem;
    margin-top: -0.65rem;
    outline: none;
    position: absolute;
    top: 50%;
    transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;
    width: 1rem;
  }
  .input-range__slider {
    width: 0.8rem;
    height: 0.8rem;
    object-fit: contain;
    border: solid 0.2rem #2276e3;
    background: #ffffff;
    margin-top: -0.5rem;
  }
  .input-range__slider:active {
    transform: scale(1.3);
  }
  .input-range__slider:focus {
    box-shadow: 0 0 0 5px rgba(63, 81, 181, 0.2);
  }
  .input-range--disabled .input-range__slider {
    background: #cccccc;
    border: 1px solid #cccccc;
    box-shadow: none;
    transform: none;
  }

  .input-range__slider-container {
    transition: left 0.3s ease-out;
  }

  .input-range__label {
    color: #aaaaaa;
    font-family: 'Rubik';
    font-size: 0.8rem;
    transform: translateZ(0);
    white-space: nowrap;
  }

  .input-range__label--min,
  .input-range__label--max {
    bottom: -1.4rem;
    position: absolute;
  }

  .input-range__label--min {
    left: 0;
  }

  .input-range__label--max {
    right: 0;
  }

  .input-range__label--value {
    position: absolute;
    top: -1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5.9rem;
    height: 2.2rem;
    background-color: #2276e3;
    font-weight: 600;
    line-height: 1.29rem;
    color: #ffffff;
    border-radius: 0.3rem;
  }

  .input-range__label-container {
    position: relative;
    font-weight: 600;
    text-align: center;
    font-size: 13px;
  }
  .input-range__label--max .input-range__label-container {
    left: 50%;
  }
  .input-range .input-range__track .input-range__slider-container:last-child .input-range__label {
    top: 0.9rem;
    left: 0;
  }

  .input-range__track {
    background: #eeeeee;
    border-radius: 0.3rem;
    cursor: pointer;
    display: block;
    height: 0.3rem;
    position: relative;
    transition: left 0.3s ease-out, width 0.3s ease-out;
  }
  .input-range--disabled .input-range__track {
    background: #eeeeee;
  }

  .input-range__track--background {
    left: 0;
    margin-top: -0.15rem;
    position: absolute;
    right: 1rem;
    top: 50%;
  }

  .input-range__track--active {
    background: #3f51b5;
  }

  .input-range {
    height: 1rem;
    position: relative;
    width: 100%;
  }
`;
